export default class session {
  static set(key: string, value: any) {
    if (value === null || value === undefined) {
      sessionStorage.removeItem(key);
      return;
    }
    if (value) {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
  }
  static get(key: string): any {
    const value: string | null = sessionStorage.getItem(key);
    if (value && value != "undefined" && value != "null") {
      return JSON.parse(value);
    }
    return null;
  }
}
